import SEO from "@/components/public/SEO";

export default function LegalPage({ kind = "privacy" }) {
  const titles = {
    privacy: { t: "Gizlilik Politikası", h: "Gizlilik" },
    terms: { t: "Kullanım Koşulları", h: "Koşullar" },
    kvkk: { t: "KVKK Aydınlatma Metni", h: "KVKK" },
  };
  const meta = titles[kind] || titles.privacy;
  return (
    <>
      <SEO title={meta.t} description="Capella Cave yasal bilgilendirme metinleri." />
      <section className="pt-40 pb-16 max-w-3xl mx-auto px-6 md:px-10">
        <div className="text-[11px] tracking-overline uppercase text-cc-sepia mb-5">Yasal</div>
        <h1 className="font-serif text-5xl md:text-7xl text-cc-text leading-none mb-12">{meta.h}</h1>
      </section>
      <article className="pb-32 max-w-3xl mx-auto px-6 md:px-10 prose-edit">
        <p>Bu sayfa, Capella Cave'in yasal bilgilendirme metnini içerir. Detayların açılış öncesi tamamlanacağını belirtmek isteriz.</p>
        <p>Verilerinizi yalnızca size daha iyi hizmet vermek için kullanırız ve üçüncü taraflarla paylaşmayız. KVKK kapsamında haklarınız saklıdır.</p>
      </article>
    </>
  );
}
